import { getOrientationType } from '@/static/js/screen.js'

export default {
    // 设置屏幕目标方向
    setExpectedOrientationType(state,type){
      state.expectedOrientationType = type;
      state.currentOrientationType = getOrientationType()
    },
    // 设置屏幕当前方向
    setCurrentOrientationType(state,type){
      state.currentOrientationType = type||getOrientationType()
    },
    setIsIgnoreScreenOrientation(state, flag = false){
      state.isIgnoreScreenOrientation = flag
    }
  }